var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9167 6.25H6.25V47.9167H47.9167V6.25Z",
    fill: "#E86C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 6.25H52.0833V47.9167H93.75V6.25Z",
    fill: "#72C472"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9167 52.0833H6.25V93.75H47.9167V52.0833Z",
    fill: "#43A6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 52.0833H52.0833V93.75H93.75V52.0833Z",
    fill: "#EFD358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMicrosoft);
export default __webpack_public_path__ + "static/media/play-microsoft.c644b4728710fa5bc5750ce518fec4f0.svg";
export { ForwardRef as ReactComponent };